import { Component, OnInit, OnDestroy } from '@angular/core';
import { SearchService } from '../../search/search.service';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { ModalService } from '../../services/modal.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { SearchCriteria, Condition, Clause } from '../../search/models/search-filter-model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { ReshipCellRendererComponent } from './custom-cell-renderers/reship-cell-renderer/reship-cell-renderer.component';
import { SearchEvent } from '../../search/models/search-event';
import { ITEM_CLICK_EVENT, NEW_SEARCH_EVENT } from '../../search/search-constants';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { AlertService } from 'sce-core';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'lfwms-wave-ship-reship-popup',
  templateUrl: './wave-ship-reship-popup.component.html',
  styleUrls: ['./wave-ship-reship-popup.component.css']
})
export class WaveShipReshipPopupComponent implements OnInit, OnDestroy {


  public lookupSearchService: SearchService;
  private _mbolKeyWarningNoMap = {};
  private _waveKey: string ;
  public searchEventSubscription: Subscription;
  public primarySelectedDocument: any;
  public detailSearchService: SearchService;
  public showSearchPage: boolean = true;
  public showDetailPage: boolean = false;
  public showPopulatePage: boolean = false;
  public dataEditor: any;
  public resourceService: any;
  public lblBack: string = '';
  public navigatedLineItemFromSearch: any;
  public searchSearchService: SearchService;

  constructor(public modalService: ModalService,
    public coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService) {
    this.resourceService = this.coreServiceRegistry.resourceService;
    this.lblBack = this.resourceService.get('lbl_agn_back');
  }

  ngOnInit() {
    // LFWM-3071-when the hyperLink is clicked navigateToDetailPage is called.
    this.searchEventSubscription = this.lookupSearchService.receiveEvent()
      .subscribe(($event: SearchEvent) => {
        if ($event.type === ITEM_CLICK_EVENT) {
          this.navigateToDetailPage($event.selectedItemId);
        }
      });
  }
  /*
  Cleanup: Not used currently.
    public registerCallback(callback: any, parentRef: any) {
        this.callbackFunction = callback;
        this.parentRef = parentRef;
    }
  */
  /*
   Ship operation is impelmented as loadByPAge call
    that returns ship action status as table data.
 */
  public initializeComponents(waveKey: string, mbolKeyList?: string[]) {
    this._waveKey = waveKey; // will be used for reship operation.
    // initialize the table and search context */
    this.initializeLookupSearchContext();
    this.showSearchPage = true;
    this.showDetailPage = false;
    // call the ship loadbypage for doing ship action.
    this._doShipAndGetResponseTableData(waveKey, mbolKeyList);
  }



  /* initialize the table and search context */
  public initializeLookupSearchContext() {
    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = 'WAVESHIPTD';
    searchParams.isFullFetch = true;
    searchParams.columnCount = 15; ///???
    // LFWM-3071- mbolKey is made as hyperlink to navigate to ship status error log
    searchParams.idProperty = 'mbolKey';
    /* Data editor is needed  for tableheader filter to work.
  Filter might misbehave if datatype is not set properly in metdata from db. */
    searchParams.tableEditor = new DataTableEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    // Client side pagination enabled
    searchParams.paginateLocally = true;
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.defaultCellRenderer = ReshipCellRendererComponent;
    tableConfig.enablePagination = true;
    tableConfig.enableFilter = true;
    tableConfig.showIdAsAHyperLink = true;
    searchParams.dataTableConfig = tableConfig;
    const searchStatus: SearchStatus = new SearchStatus();
    this.lookupSearchService = this.sharedServiceRegistry.createSearchService(searchParams,
      searchStatus);

  }
  
  /*
  Ship API call and get response as loadBypage call.
    - set mbolkey->warningNo mapping from response for use in reship calls
    - clears the search criteria used for loadBypage request
      since it will conflict with logic for localpagination's paging, sort, filter etc.
  */
  private _doShipAndGetResponseTableData(waveKey: string, mbolKeyList?: string[]) {

    this.lookupSearchService.clearSearchStatus();
    /* above call required to clear of unexpected behaviour
   -not sending backend calls from second time when multiple parellel requests are sent */
    this.lookupSearchService.setSearchCriteria(this._getNewSearchCriteria(waveKey, mbolKeyList));
    // not reflecting?? this.lookupSearchService.pagedData.pageDefinition.pageSize = 1000;
    // this.lookupSearchService.performSearch();
    // subscribe needed as we need to set mbolkey->warningNo mapping and clear search criteria;
    this.lookupSearchService.fetchSearchResults()
      .subscribe((data: any) => {
        this.lookupSearchService.searchStatus.hasResults = true;
        this.lookupSearchService.searchStatus.recordCount = this.lookupSearchService.pagedData.pageDefinition.recordCount;
        const event = new SearchEvent(NEW_SEARCH_EVENT);
        event.isSearchSuccess = true;
        this.lookupSearchService.publishEvent(event);

        /* Save the warningNo received from ship-response against each MBOLkEY
        This is requried in case of reship operation */
        this.lookupSearchService.getAllRows().forEach(row => {
          this._mbolKeyWarningNoMap[row.cells['mbolKey'].cVal] = row.cells['warningNo'].cVal;
        });
        // Clear search criteria to work with localPAgination
        this.lookupSearchService.setSearchCriteria(new SearchCriteria());
      });

  }

  /*
  Create custom search criteria for shipping wavekey/ multiple mbolkeys.
  wavekey value is also required even if mbolShip is done with values in mbolKeyList.
  ** (Custom loadByPage request manipulation is done at backend
    as a specific case for ship operation )
  */
  private _getNewSearchCriteria(waveKey: string, mbolKeyList?: string[]) {

    // set isMbolShip true if at least one MbolKey passed.
    const isMbolShip = mbolKeyList ? (mbolKeyList.length > 0) : false;
    const searchCriteria = new SearchCriteria();
    // Function snippet to reuse clause creation within this method
    const _createSearchClause = (columName: string, value: any) => {
      const clause = new Clause();
      clause.operation = '=';
      clause.column = columName;
      clause.value = value;
      clause.logicalOperation = 'AND';
      return clause;
    };

    if (isMbolShip) {
      mbolKeyList.forEach(mbolKey => {
        /* Multiple MBOLkeys needs to be sent in separate searchCondition,
        one searchCondition per MBOLKey */
        const searchCondition = new Condition();
        searchCondition.isMandatory = true;
        searchCondition.operator = 'OR';

        searchCondition.clauses = []; // Initialize clauses array
        searchCondition.clauses.push(_createSearchClause('waveKey', waveKey));
        searchCondition.clauses.push(_createSearchClause('mbolKey', mbolKey));
        searchCondition.clauses.push(_createSearchClause('keyCount', 0)); // Always 0
        const warningNo = this._mbolKeyWarningNoMap[mbolKey] ? this._mbolKeyWarningNoMap[mbolKey] : 0;
        searchCondition.clauses.push(_createSearchClause('warningNo', warningNo)); // Always 1 first and take from prev response for reship
        searchCondition.clauses.push(_createSearchClause('errorGroupKey', 0)); // Always 0
        searchCondition.clauses.push(_createSearchClause('isMbolShip', 'Y'));
        searchCondition.clauses.push(_createSearchClause('shipMode', 'MBOL'));

        searchCriteria.conditions.push(searchCondition);
      });
    } else {
      // No MBOLKey, Ship Wave => Only one searchCondition with Wavekey Clause
      // Response should be returning multiple mbolkeys within the wave.
      const searchCondition = new Condition();
      searchCondition.isMandatory = true;
      searchCondition.operator = 'AND';

      searchCondition.clauses = []; // Initialize clauses array
      searchCondition.clauses.push(_createSearchClause('waveKey', waveKey));
      searchCondition.clauses.push(_createSearchClause('keyCount', 0)); // Always 0
      searchCondition.clauses.push(_createSearchClause('warningNo', 1)); // Always 1. Reship sends mbolKeyList
      searchCondition.clauses.push(_createSearchClause('errorGroupKey', 0)); // Always 0
      searchCondition.clauses.push(_createSearchClause('isMbolShip', 'N'));
      searchCondition.clauses.push(_createSearchClause('shipMode', 'WAVE'));

      searchCriteria.conditions.push(searchCondition);
    }

    // console.log(waveKey, mbolKeyList, isMbolShip);
    // console.log(JSON.stringify(searchCriteria));

    return searchCriteria;
  }


  /*
  Reship the selected MBOLKeys.
  needs warningNo to be updated from the previous ship call response.
  This is done by mapping _mbolKeyWarningNoMap[mbolKey]
   created from the previous ship operation subscribe end.
  */
  public reShip() {
    const mBolKeysToReship = [];
    this.lookupSearchService.getSelectedRows().forEach(row => {
      mBolKeysToReship.push(row.cells['mbolKey'].cVal);
    });
    // Call ship with wavekey and MBOLkey list.
    // Only zero selection validation needed here.
    if (mBolKeysToReship.length === 0) {
      // alert no shippable mbolKeys selected
      this.alertService.error(this.coreServiceRegistry.resourceService.get('no_shippable_keys'));
      // return control.
      return;
    }
    this._doShipAndGetResponseTableData( this._waveKey, mBolKeysToReship);
  }
  // LFWM-3071-when the hyperLink(mbolKey) is clicked, navigate to detail page(ship status error log)
  public navigateToDetailPage(SelectedDocument: string) {
    // the selected data(mbolKey).
    this.primarySelectedDocument = SelectedDocument;
    // we need to reset popup header name which is accessed from coreServiceRegistry.modalService
    this.coreServiceRegistry.modalService.modalReference.overlayConfig.overlayHeader =
      this.coreServiceRegistry.modalService.modalReference.overlayConfig.overlayHeader + ' / ' + this.resourceService.get('mbol_key') + this.primarySelectedDocument + ' ' + this.resourceService.get('error_id');
    const detailTableId = 'mbolerrortd';
    this.detailSearchService = this.createDetailSearchService(detailTableId);
    this.showSearchPage = false;
    this.showDetailPage = true;
    // below loop is to retrieve selected mbolKey's key lineitem
    // which is to be used for populating the search criteria
    this.navigatedLineItemFromSearch = this.lookupSearchService.pagedData.pageRows
      .filter((row) => (row.cells['mbolKey'].cVal === this.primarySelectedDocument))[0];
    const searchCriteria = this.createSearchCriteria('mbolKey', this.navigatedLineItemFromSearch);
    // set the search criteria
    this.detailSearchService.setSearchCriteria(searchCriteria);
    // metadata and loadby page call is done
    this.detailSearchService.fetchMetadata().subscribe((metadata) => {
      this.detailSearchService.performSearch();
    });
  }
  private createDetailSearchService(tableId: string): SearchService {
    const searchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    tableConfig.defaultCellRenderer = ReshipCellRendererComponent;
    searchParams.dataTableConfig = tableConfig;
    searchParams.alertService = this.alertService;
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    return searchService;
  }

  public createSearchCriteria(primaryKey: string, lineItem: any) {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition1 = this.createDefaultSearchCondition(1);
    defaultCondition1.isMandatory = false;
    defaultCondition1.operator = 'AND';
    const defaultClause1 = new Clause();
    defaultClause1.column = primaryKey;
    defaultClause1.value = lineItem.cells[primaryKey].cVal;
    defaultClause1.operation = '=';
    defaultClause1.logicalOperation = null;
    defaultCondition1.clauses = [defaultClause1];
    defaultSearchCriteria.conditions.push(defaultCondition1);
    return defaultSearchCriteria;
  }
  protected createDefaultSearchCondition(id: any) {
    const defaultCondition = new Condition();
    defaultCondition.id = id;
    defaultCondition.displayMode = 'VIEW';
    return defaultCondition;
  }
  public backToSearchPage() {
    this.lookupSearchService.performSearch();
    this.showDetailPage = false;
    this.showSearchPage = true;
    // on navigation need to change popup component title
    const popupTitle = this.resourceService.get('lbl_pop_ship_header');
    this.coreServiceRegistry.modalService.modalReference.overlayConfig.overlayHeader = popupTitle;
  }

  public ngOnDestroy() {
    if (this.searchEventSubscription) {
      this.searchEventSubscription.unsubscribe();
    }
  }
}




// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/wave-ship-reship-popup/wave-ship-reship-popup.component.ts